import React from "react";
import {
  IconBookMark,
  IconCart,
  IconHomeCheck,
  IconLoadCaretLeftRight,
  IconLoads,
  IconNoteClip,
  IconSteering,
  IconTruck,
  IconUsers,
} from "../../Common/Icons";

export const masterSearchHeader = [
  { 
    title: "All",
    icon: "",
    icon2: "",
    key: "ALL",
    apiText: 'all'
  },
  { 
    title: "Loads",
    icon: <IconLoads className="wh-20px" />,
    icon2: <IconLoads className="mr-2" />,
    key: "LOAD",
    apiText: 'loads'
  },
  {
    title: "Container Owners",
    icon: <IconBookMark className="wh-20px" />,
    icon2: <IconBookMark className="mr-2" />,
    key: "CONTAINEROWNER",
    apiText: 'containerOwners'
  },
  {
    title: "Customers",
    icon: <IconUsers className="wh-20px" />,
    icon2: <IconUsers className="mr-2" />,
    key: "CUSTOMER",
    apiText: 'customers'
  },
  {
    title: "Container Types",
    icon: <IconNoteClip className="wh-20px" />,
    icon2: <IconNoteClip className="mr-2" />,
    key: "CONTAINERTYPE",
    apiText: 'containerypes'
  },
  {
    title: "Chassis Owners",
    icon: <IconHomeCheck className="wh-20px" />,
    icon2: <IconHomeCheck className="mr-2" />,
    key: "CHASSISOWNER",
    apiText: 'chassisOwners'
  },
  {
    title: "Chassis Types",
    icon: <IconLoadCaretLeftRight className="wh-20px" />,
    icon2: <IconLoadCaretLeftRight className="mr-2" />,
    key: "CHASSISTYPE",
    apiText: 'chassisTypes'
  },
  {
    title: "Drivers",
    icon: <IconSteering className="wh-20px" />,
    icon2: <IconSteering className="mr-2" />,
    key: "DRIVER",
    apiText: 'drivers'
  },
  {
    title: "Trucks",
    icon: <IconTruck className="wh-20px" />,
    icon2: <IconTruck className="mr-2" />,
    key: "TRUCKS",
    apiText: 'trucks'
  },
  {
    title: "Trailers",
    icon: <IconCart className="wh-20px" />,
    icon2: <IconCart className="mr-2" />,
    key: "TRAILER",
    apiText: 'trailers'
  },
];
